export default __webpack_public_path__ + "static/media/CompTIA_PenTest_2B.9d1c6aef.png";